import * as React from 'react';

const Error = ({ meta : {touched, error} }) =>  (touched && error ? <div>{error}</div> : null);

export const CheckboxGroup = ({ name, options,  input, meta}) => (
  <div>
      { options.map((option, index) => (
        <div className="form-check" key={index}>
          <label className="form-check-label">
            <input type="checkbox" className="form-check-input"
                   name={index + '-checkgroup'}
                   value={option.name}
                   checked={input.value.indexOf(option.name) !== -1}
                   onChange={event => {
                     let newValue = input.value === '' ? [] : [...input.value];
                     if (event.target.checked) {
                       newValue.push(option.name);
                     } else {
                       newValue.splice(newValue.indexOf(option.name), 1);
                     }
                     return input.onChange(newValue);
                   }}/>
            {option.name}
          </label>
        </div>))
      }
    <Error meta={meta} />
  </div>
);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/_global/components/form-elements/checkbox-group.tsx